import { useState } from "react";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import api from "../../../api";

const defaultPreferences = [
  {
    id: "new_users",
    label: "New user registrations",
    sub: "Get notified when a new user signs up",
    enabled: true,
  },
  {
    id: "user_reports",
    label: "User reports",
    sub: "Alerts when a user is reported",
    enabled: true,
  },
  {
    id: "system_alerts",
    label: "System alerts",
    sub: "Critical system and security notifications",
    enabled: true,
  },
  {
    id: "weekly_summary",
    label: "Weekly summary",
    sub: "Weekly digest of platform activity",
    enabled: false,
  },
];

const Notifications = () => {
  const [preferences, setPreferences] = useState(defaultPreferences);
  const [saving, setSaving] = useState(false);

  const handleToggle = (id) => {
    setPreferences((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, enabled: !item.enabled } : item
      )
    );
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      // await api.patch("/admin-management/update-notifications", { preferences });
      toast.success("Notification preferences saved!");
    } catch (err) {
      toast.error("Failed to save preferences");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="profile-card">
      <div className="profile-card-header">
        <div>
          <h3>Notification Preferences</h3>
          <p>Choose what notifications you want to receive.</p>
        </div>
        <Button
          variant="contained"
          color="primary"
          size="small"
          disabled={saving}
          onClick={handleSave}
        >
          {saving ? "Saving..." : "Save Preferences"}
        </Button>
      </div>

      <div className="notifications-list">
        {preferences.map((item) => (
          <div key={item.id} className="notification-item">
            <div>
              <p className="notification-label">{item.label}</p>
              <p className="notification-sub">{item.sub}</p>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                checked={item.enabled}
                onChange={() => handleToggle(item.id)}
              />
              <span className="toggle-slider" />
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notifications;